<script>
    import { createFilter } from '@/api/filters.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_FILTER_ADD},
        },
        methods: {
            async create() {
                const data = this.$store.getters.FILTER_DATA_ADD;
                const response = await createFilter(data);
                if (response != null) {
                    this.$store.commit('FILTERS_PUSH', {
                        assetID: response.asset_type_id,
                        payload: response,
                        parentID: response.parent_id
                    })
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_FILTER_ADD', false);
            },
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        @click="create"
        class="button_blue_100"
    >Create</button>
    <button
        @click="close"
        class="button_blue_100 close_button mr_10"
    >Close</button>
</template>